<template>
  <div>
    <div class="img" :style="`background-image:url(` + imgUrl + `)`">
      <div class="mask-icon">
        <img src="/static/img/icon-download-ebook.svg" alt="descargar ebook" />
      </div>
    </div>
    <div class="content">
      <p class="title">{{ nameEbook }}</p>
      <p class="descrip">
        {{ descriptionEbook }}
      </p>
    </div>
  </div>
</template>

<script lang="js">
    import Vue from 'vue';
    import {mapGetters, mapActions} from 'vuex'
    export default  {
    name: 'ebook-el',
    props: ['data','nameEbook','imgUrl','descriptionEbook','attached','idEbook'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {


    },
    computed: {
      ...mapGetters({
        lang : 'getLanguage'
      })
    }
}
</script>

<style>
.contenedor-input {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
}

.contenedor-input label {
  width: 100%;
  font-family: "Ubuntu Mono";
  font-size: 18px;
  line-height: 28px;
  color: #3374b0;
  display: inline-block;
  text-align: left;
  margin-bottom: 5px;
}

.contenedor-input input,
.contenedor-input textarea,
.contenedor-input select {
  width: 100%;
  text-align: left;
  padding: 0 15px;
  color: #3374b0;
  height: 40px;
  line-height: 40px;
  border: 1px solid #3374b0;
  outline: none;
}

.contenedor-input textarea {
  height: 160px;
  resize: none;
}

.contenedor-input input::placeholder,
.contenedor-input textarea::placeholder {
  color: #3374b0;
}

.dropdown {
  width: 40px;
  height: 40px;
  background: url(/static/img/next-blue.svg) center/13px no-repeat;
  position: absolute;
  right: 0;
  bottom: 20px;
  transform: rotate(90deg);
}

.btn-rounded-blue {
  min-width: 150px;
  outline: none;
  margin-top: 20px;
}

.contenedor-check {
  padding-bottom: 15px;
}
.contenedor-check input {
  z-index: 1;
}
.contenedor-check label {
  color: #3374b0;
}

.contenedor-check label::before {
  border-color: #3374b0;
}

.contenedor-check input:checked + label::before {
  color: #3374b0;
}

.error {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  color: #df1517;
  font-size: 12px;
  text-align: left;
}

.gracias {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 55px;
  line-height: 55px;
  text-align: center;
  width: 100%;
  font-family: "Ubuntu Mono";
  font-size: 24px;
  color: #3374b0;
  text-transform: uppercase;
  opacity: 0;
  pointer-events: none;
}
.form-ebook {
  position: relative;
}
.form-ebook .btnClose {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  background: url(/static/img/boton-cerrar.png);
  background-size: 30px;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/ebook-el.vue